import React from "react";
import "./loader.css";

export default function Loader(backgroundColor) {
  const color = backgroundColor;
  return (
    <div
      className="center"
      style={{ backgroundColor: `${color.backgroundColor}` }}
    >
      <div className="ring"></div>
      <img src="./images/Logos/flash.svg" alt="logo"></img>
    </div>
  );
}
